import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistorySummaryInfo } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';

import { IConsistencyCheckHistoryInfoSummary } from '@interfaces/cmModule/consistencyCheck';
import { IId } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_INFO_SUMMARY } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryInfoSummaryReturned {
	consistencyCheckInfoSummary?: IConsistencyCheckHistoryInfoSummary;
	isLoadingConsistencyCheckHistoryInfoSummary: boolean;
}

const useConsistencyCheckHistoryInfoSummary = ({
	id,
}: Partial<IId>): IUseConsistencyCheckHistoryInfoSummaryReturned => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_INFO_SUMMARY, { id }],
		queryFn: extractQueryParams(getConsistencyCheckHistorySummaryInfo),
		enabled: [!!id],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckInfoSummary: data,
		isLoadingConsistencyCheckHistoryInfoSummary: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistoryInfoSummary;
